import MainPageHeader from "common/components/MainPageHeader";
import FormComponent from "features/contactUs/components/FormSection/FormComponent";
import React from "react";
import ModalContact from "screens/Landing/components/ModalContact";

interface Props {
  setShowModalContact: any;
  showModalContact?: any;
}

const ContactScreenMobile = ({ showModalContact, setShowModalContact }: Props) => {
  return (
    <div className="wrapper-bg-contact-us wrapper-bg-contact-us-mobile">
      <div className="bg-contact-us">
        <MainPageHeader title="צור קשר" />
        <div className="container-contact-us">
          <div className="wrapper-contact-us">
            <FormComponent onSuccess={() => setShowModalContact(true)} />
          </div>
        </div>
        <ModalContact show={showModalContact} onHide={() => setShowModalContact(false)} />
      </div>
    </div>
  );
};

export default ContactScreenMobile;
